import React, { useEffect, useState } from 'react';

import { useContext } from 'react';
import { AxiosError } from 'axios';
import { Card, Flex, Grid, Modal } from 'antd';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { AreaRestritaUsuarioService } from '../../../Services/Domain/AreaRestrita/UsuarioService';
import { ConfigurarSessaoDoUsuario, PainelLogin } from './Acesso.login';
import { PainelPublicoDeCadastroDeResponsavel } from './Acesso.cadastro';
import { SessaoARContext } from '../../Contexts/SessaoContext';
import { notificarErroNaRequisicao } from '../../../Utils/Notificacoes';
import { CardTabListType } from 'antd/lib/card';

export const Acesso = () => {
    const breakpoints = Grid.useBreakpoint();

    const navigate = useNavigate()
    const SessaoAR = useContext(SessaoARContext);

    const [activeTabKey, setActiveTabKey] = useState<'login'|'cadastro'>('login');

    const onTabChange = (key: string) => {
        setActiveTabKey(key as 'login'|'cadastro');
    };
  
    const tabListNoTitle = [
        {
          key: 'login',
          label: 'Já sou cadastrado'
        },
        {
          key: 'cadastro',
          label: 'Faça seu cadastro'
        },
    ] as CardTabListType[];
      
    const contentListNoTitle = {
        login : <PainelLogin hrefCadastro={`/autenticacao/cadastro`} />,
        cadastro : <PainelPublicoDeCadastroDeResponsavel hrefCancelar={undefined} depoisDeCadastrar={async (usuarioCadastrado, formulario) => {
            try {
                const resposta = await new AreaRestritaUsuarioService().logar({
                    email: formulario.email,
                    senha: formulario.senha
                });

                ConfigurarSessaoDoUsuario(resposta.data, SessaoAR?.setSessao);
                navigate(localStorage.getItem("Rota_Get_AreaRestrita") ?? '/viagens');
            } catch (error) {
                if(error instanceof(AxiosError)){
                    notificarErroNaRequisicao(error)
                } else {
                    throw error;
                }
            }
        }} />
    };
    return (
        <React.Fragment>
            {/* <Modal>

            </Modal> */}
            {/* <Flex justify="center" align="center" style={{ paddingTop : "20px" }}> */}
                <Card 
                    tabList={tabListNoTitle}
                    activeTabKey={activeTabKey}
                    onTabChange={onTabChange}
                    tabProps={{
                      size: 'middle',
                      type : "card",
                    }}
                    style={{
                        marginTop : 40,
                        marginBottom : 40
                    }}
                >
                    {contentListNoTitle[activeTabKey]}
                    {/* <Routes>
                        <Route index element={
                            <PainelLogin hrefCadastro={`/autenticacao/cadastro`}
                            />
                        } />

                        <Route 
                            path='/cadastro'
                            element={
                                <PainelPublicoDeCadastroDeResponsavel hrefCancelar='/' depoisDeCadastrar={async (usuarioCadastrado, formulario) => {
                                    try {
                                        const resposta = await new AreaRestritaUsuarioService().logar({
                                            email: formulario.email,
                                            senha: formulario.senha
                                        });

                                        ConfigurarSessaoDoUsuario(resposta.data, SessaoAR?.setSessao);
                                        navigate(localStorage.getItem("Rota_Get_AreaRestrita") ?? '/viagens');
                                    } catch (error) {
                                        if(error instanceof(AxiosError)){
                                            notificarErroNaRequisicao(error)
                                        } else {
                                            throw error;
                                        }
                                    }
                                }} />
                            } 
                        />

                        <Route path='*' element={<Navigate to={"/"} />} />

                    </Routes> */}
                </Card>
            {/* </Flex> */}
        </React.Fragment>
    );
}